var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.15625H10.5625C10.4938 0.15625 10.4375 0.2125 10.4375 0.28125V8.375H2.84376V7.23438C2.84376 7.12969 2.72189 7.07031 2.64064 7.13594L0.423449 8.88594C0.408509 8.89763 0.396426 8.91257 0.388116 8.92963C0.379807 8.94668 0.375488 8.9654 0.375488 8.98438C0.375488 9.00335 0.379807 9.02207 0.388116 9.03912C0.396426 9.05618 0.408509 9.07112 0.423449 9.08281L2.64064 10.8328C2.72345 10.8984 2.84376 10.8391 2.84376 10.7344V9.5625H10.625C11.1766 9.5625 11.625 9.11406 11.625 8.5625V0.28125C11.625 0.2125 11.5688 0.15625 11.5 0.15625Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.6d58476caf60c073417ec04832876198.svg";
export { ForwardRef as ReactComponent };